/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks/Hook"
import { Card, Col, Container, Row } from "react-bootstrap"
import { Button } from "../../../components"
import { toast } from "react-toastify"
import { CustomerCourtBookingStep1 } from "./CustomerCourtBookingStep1"
import { CustomerCourtBookingStep2 } from "./CustomerCourtBookingStep2"
import { CustomerCourtBookingStep3 } from "./CustomerCourtBookingStep3"
import { CustomerCourtBookingSummary } from "./CustomerCourtBookingSummary"
import { GetProfile } from "../../../redux/Slice/Profile/ProfileDetailSlice"
import { messages } from "../../../utilities/Messages";
const getMessage = messages.courts;

const CustomerCourtBooking = () => {
  const dispatch = useAppDispatch()
  const { SelectedFacility } = useAppSelector(state => state.facilityList)
  const [currentStep, setCurrentStep] = useState(0);
  const [courtBookingData, setCourtBookingData] = useState({
    facilityId: SelectedFacility ? Number(SelectedFacility) : "",
    sportId: "",
    selectedSlots: [],
    isIgstTax: "false",
    paymentMethod: "online"
  })
  const [rules, setRules] = useState([]) as any

  useEffect(() => {
    setCourtBookingData({ ...courtBookingData, facilityId: Number(SelectedFacility) || "" })
    if (SelectedFacility === "") {
      toast.error(getMessage.facility_required)
    }
  }, [SelectedFacility])

  useEffect(() => {
    dispatch(GetProfile());
  }, []);

  const handleBack = () => {
    setCurrentStep((_oldVal) => {
      if (_oldVal > 0) {
        return --_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            {currentStep !== 0 && (
              <>
                <Row>
                  <Col className="text-start">
                    <Button
                      type="button"
                      bname="Back"
                      name="back"
                      id="back"
                      className="btn btn-primary rounded-1 me-3"
                      onClick={handleBack}
                    ></Button>
                  </Col>
                </Row>
                <hr />
              </>
            )}
            {
              currentStep === 0 && <CustomerCourtBookingStep1 courtBookingData={courtBookingData} setCourtBookingData={setCourtBookingData} setCurrentStep={setCurrentStep} setRules={setRules} />
            }
            {
              currentStep === 1 && <CustomerCourtBookingStep2 courtBookingData={courtBookingData} setCourtBookingData={setCourtBookingData} setCurrentStep={setCurrentStep} />
            }
            {
              currentStep === 2 && <CustomerCourtBookingStep3 rules={rules} setCurrentStep={setCurrentStep} />
            }
            {
              currentStep === 3 && <CustomerCourtBookingSummary courtBookingData={courtBookingData} setCourtBookingData={setCourtBookingData} />
            }

          </Card.Body>
        </Card>
      </Container>
    </>
  )
}
export { CustomerCourtBooking }
